import { render, staticRenderFns } from "./indexRightChart.vue?vue&type=template&id=61145fe2&scoped=true&"
import script from "./indexRightChart.vue?vue&type=script&lang=js&"
export * from "./indexRightChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61145fe2",
  null
  
)

export default component.exports